module.exports = __webpack_public_path__ + "img/shopping_cart2.25ffc29b.svg";